import React from "react";

export default function Backdrop({ toggleSidebar }) {
  return (
    <div
      className="fixed inset-0 bg-black/50 z-[99]"
      onClick={() => toggleSidebar(false)}
    />
  );
}
